import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = {
  key: 0,
  class: "breadcrumbs__breadcrumb"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "breadcrumbs__active" }

import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    title: {}
  },
  setup(__props: any) {

const {t} = useI18n()

// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$route.matched, (matched, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (i+1 < _ctx.$route.matched.length && matched.path != _ctx.$route.path)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              (!matched.meta.noLinkInBreadcrumbs)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: matched.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(`routes.${matched.name?.toString()}.name`)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)(`routes.${matched.name?.toString()}.name`)), 1))
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.title), 1)
  ]))
}
}

})